import { switchComponentProps } from '../../utils/component';
import { SwitchProps, SwitchReturnType } from './switch.types';

export const switchProps = (props: SwitchProps): SwitchReturnType => {
  const { color = 'primary', switchStatus = true } = props;

  const defaultProps = switchStatus
    ? switchComponentProps[`${color}Label`]
    : '';
  const inputProps = switchStatus ? switchComponentProps[`${color}Input`] : '';

  return {
    input: inputProps.toString(),
    label: defaultProps.toString()
  };
};
